// Tarifas centralizadas - Fácil de actualizar
// Última actualización: 04/2026

const pricingData = {
    fisioterapia: {
        title: "Sesiones de Fisioterapia",
        icon: "💆",
        description: "La primera sesión incluye apertura de la historia clínica, valoración y pauta de tratamiento. Duración aproximada: 45 minutos.",
        services: [
            {
                name: "Sesión de fisioterapia",
                price: "40€",
                duration: "45 min aprox."
            },
            {
                name: "Sesión de fisioterapia + ecografía",
                price: "50€",
                duration: "60 min aprox."
            },
            {
                name: "Bono 5 sesiones",
                price: "180€",
                duration: "36€/sesión",
                highlight: true,
                note: "Tratamiento de rehabilitación mínimo 1 día por semana"
            },
            {
                name: "Bono 10 sesiones",
                price: "330€",
                duration: "33€/sesión",
                highlight: true,
                note: "Tratamiento de rehabilitación mínimo 1 día por semana"
            },
            {
                name: "Sesión a domicilio",
                price: "50€",
                duration: "45 min aprox."
            },
            {
                name: "Bono 10 sesiones domicilio",
                price: "450€",
                duration: "45€/sesión",
                highlight: true
            }
        ]
    },
    ejercicioDirigido: {
        title: "Ejercicio Dirigido",
        icon: "🏋️",
        description: "Todos los pacientes deberán hacer una primera sesión de valoración antes de iniciar las clases. El pago de las clases es mensual al inicio del mes.",
        services: [
            {
                name: "Fisioactive (6 personas)",
                price: "30€/mes",
                duration: "1 día/semana",
                group: "6 personas"
            },
            {
                name: "Fisioactive (6 personas)",
                price: "50€/mes",
                duration: "2 días/semana",
                group: "6 personas",
                highlight: true
            },
            {
                name: "Running + planning individualizado",
                price: "35€/mes",
                duration: "1 día/semana"
            },
            {
                name: "Hipopresivos",
                price: "35€/mes",
                duration: "Variable",
                group: "Mínimo 4 personas"
            }
        ]
    }
};

export default pricingData;
